import { render, staticRenderFns } from "../integrations/integrations.html?vue&type=template&id=2b70b5f2&scoped=true&external"
import script from "../integrations/integrations.js?vue&type=script&lang=js&external"
export * from "../integrations/integrations.js?vue&type=script&lang=js&external"
import style0 from "../integrations/integrations.css?vue&type=style&index=0&id=2b70b5f2&prod&scoped=true&lang=css&external"
import style1 from "./Integrations.vue?vue&type=style&index=1&id=2b70b5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70b5f2",
  null
  
)

export default component.exports